import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import ParameterList from '../components/admin/ParameterList';
import '../css/style.css';
import '../components/Home.css';

class ParametersLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="0">
                <Row>
                    <Col xl={6}>
                    <ParameterList />
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default ParametersLayout;